import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';  
import { RootState } from '../../store/store'; 
import { Grid, Container, Typography,Box } from '@mui/material';  
import { useParams } from "react-router-dom";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { FORGOT_PASSWORD_EMAIL, VALIDATION_ERROR_CONFIRM_PASSWORD_REQUIRED_MESSAGE, VALIDATION_ERROR_PASSWORD_LOWERCASE_REQUIRED_MESSAGE, VALIDATION_ERROR_PASSWORD_NOT_MATCH_REQUIRED_MESSAGE, VALIDATION_ERROR_PASSWORD_NUMBER_REQUIRED_MESSAGE, VALIDATION_ERROR_PASSWORD_REQUIRED_MESSAGE, VALIDATION_ERROR_PASSWORD_SPECIAL_REQUIRED_MESSAGE, VALIDATION_ERROR_PASSWORD_UPPERCASE_REQUIRED_MESSAGE, VALIDATION_ERROR_REQUIRED_MESSAGE } from '../../constants/actions';
import { SignInFormStyles } from '../../assets/css/signInForm.styles';  
import { useAppDispatch } from '../../hooks/useAppDispatch';
import CustomTextField from '../../components/customTextField/customTextField';
import CustomButton from '../../components/customButton/customButton';
import Loader from '../../components/loader';
import { changePassword, forgotPassword } from '../../reducers/authReducer';
import { Lowercase, Numbercase, passwordCharactersMinimum, SpecialChar, Uppercase } from '../../constants/registerConstants';

const ChangePasswordForm: React.FC = () => {
  const [password, setPassword] = useState('');  
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isVisible, setIsVisible] = useState(false); 
  const [touched, setTouched] = useState({ password: false, confirmPassword:false });
  const authState = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id } = useParams();
 
useEffect(() => {
    if(!id){
        navigate('/ForgotPassword');
    }
}, [id]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (password.length < passwordCharactersMinimum || !Uppercase.test(password) || !Lowercase.test(password) || !Numbercase.test(password) || !SpecialChar.test(password)) { 
        toast.error(VALIDATION_ERROR_PASSWORD_REQUIRED_MESSAGE)
        return;
    }
    if (confirmPassword !== password) { 
        toast.error(VALIDATION_ERROR_PASSWORD_NOT_MATCH_REQUIRED_MESSAGE)
        return;
    }
    dispatch(changePassword({ id:id?.toString() || "", password: password })).unwrap()  
    .then((response) => { 
        const { message, success } = response.data;   
       if(success){
            toast.success(`${message}`); 
            navigate('/')
        }
        else{
            toast.error(`${message}`); 
        }  
    }).catch((error) => {
        if (error.response && error.response.data && error.response.data.message) {
            toast.error(error.response.data.message);
        } else {
            toast.error("An unexpected error occurred. Please try again."); 
        }
        console.error("Failed to save item:", error);
    }); 
  };

  const handlePasswordBlur = () => { 
      if (password.length < passwordCharactersMinimum || !Uppercase.test(password) || !Lowercase.test(password) || !Numbercase.test(password) || !SpecialChar.test(password)
    ) {
          setTouched((prevData) => ({
              ...prevData,
              password: true,
          })) 
      } 
    };
  
  const handleConfirmPasswordBlur = () => { 
      if (confirmPassword.trim() === "" || confirmPassword !== password) {
          setTouched((prevData) => ({
              ...prevData,
              confirmPassword: true,
          })) 
      } 
    }; 

  return (
    <Container component="main" maxWidth="sm"  sx={SignInFormStyles.container}>
        <div> 
            <Typography variant="h5" component="h2" align="center" sx={{ marginBottom:"25px" }}>
                Reset Password
            </Typography>
        </div>  
        <Box component="form" onSubmit={handleSubmit} noValidate style={SignInFormStyles.form}> 
            <CustomTextField 
                label="New Password"
                name="password"
                type={isVisible ? "text" :"password"}
                value={password}
                icon={isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                onClickOnIcon={() => setIsVisible(!isVisible)}  
                onChange={(e) =>
                setPassword(e.target.value)
                }
                required={true}
                onBlur={handlePasswordBlur}
                error={touched.password && (
                password.trim() === "" || password.length < passwordCharactersMinimum || !Uppercase.test(password) || !Lowercase.test(password) || !Numbercase.test(password) || !SpecialChar.test(password)  
                )}
                helperText={
                    (touched.password && (password.trim() === "" || password.length < passwordCharactersMinimum))
                    ? VALIDATION_ERROR_PASSWORD_REQUIRED_MESSAGE
                    : (touched.password && !Uppercase.test(password))  ? VALIDATION_ERROR_PASSWORD_UPPERCASE_REQUIRED_MESSAGE
                    : (touched.password && !Lowercase.test(password))  ? VALIDATION_ERROR_PASSWORD_LOWERCASE_REQUIRED_MESSAGE
                    : (touched.password && !Numbercase.test(password))  ? VALIDATION_ERROR_PASSWORD_NUMBER_REQUIRED_MESSAGE
                    : (touched.password && !SpecialChar.test(password))  ? VALIDATION_ERROR_PASSWORD_SPECIAL_REQUIRED_MESSAGE
                    : ""
                }
            />   
            <CustomTextField  
                label="Confirm Password"
                name="confirmPassword" 
                type="password" 
                value={confirmPassword}
                onChange={(e) =>
                setConfirmPassword(e.target.value) 
                }
                required={true} 
                onBlur={handleConfirmPasswordBlur}
                error={touched.confirmPassword && (confirmPassword.trim() === "" || confirmPassword !== password)} 
                helperText={
                touched.confirmPassword && confirmPassword.trim() === "" ? VALIDATION_ERROR_CONFIRM_PASSWORD_REQUIRED_MESSAGE: 
                touched.confirmPassword && confirmPassword !== password ? VALIDATION_ERROR_PASSWORD_NOT_MATCH_REQUIRED_MESSAGE  : ""}
            /> 
            <CustomButton style={SignInFormStyles.button}>
                Change Password
            </CustomButton> 
        </Box> 
    </Container>
  );
};

export default ChangePasswordForm;
